/**
 * Converts object key values into a query params string.
 *
 * @param {Object} object the object to process.
 * @returns {string} returns a string with the params.
 * @example
 *
 * const object = {
 *     key1: 'value1',
 *     key2: 'value2'
 * };
 *
 * const params = getParams(object);
 * console.log(params);
 * // => ?key1=value1&key2=value2
 */
function getParams(object: Object): string {
    const params = Object.keys(object).map(key => {
        return key + '=' + object[key];
    });
    return '?' + params.join('&');
}

export default getParams;
